/* tslint:disable */
/* eslint-disable */
/**
 * Raberu API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateJuridicalPayer } from '../models';
// @ts-ignore
import type { JuridicalPayer } from '../models';
/**
 * PayerApi - axios parameter creator
 * @export
 */
export const PayerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateJuridicalPayer} createJuridicalPayer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJuridical: async (createJuridicalPayer: CreateJuridicalPayer, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createJuridicalPayer' is not null or undefined
            assertParamExists('createJuridical', 'createJuridicalPayer', createJuridicalPayer)
            const localVarPath = `/api/v1/employer/accounting/payers/juridical`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJuridicalPayer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employer/accounting/payers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayerApi - functional programming interface
 * @export
 */
export const PayerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateJuridicalPayer} createJuridicalPayer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJuridical(createJuridicalPayer: CreateJuridicalPayer, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JuridicalPayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJuridical(createJuridicalPayer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayerApi.createJuridical']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JuridicalPayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayerApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PayerApi - factory interface
 * @export
 */
export const PayerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayerApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateJuridicalPayer} createJuridicalPayer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJuridical(createJuridicalPayer: CreateJuridicalPayer, options?: RawAxiosRequestConfig): AxiosPromise<JuridicalPayer> {
            return localVarFp.createJuridical(createJuridicalPayer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options?: RawAxiosRequestConfig): AxiosPromise<Array<JuridicalPayer>> {
            return localVarFp.list(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PayerApi - interface
 * @export
 * @interface PayerApi
 */
export interface PayerApiInterface {
    /**
     * 
     * @param {CreateJuridicalPayer} createJuridicalPayer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayerApiInterface
     */
    createJuridical(createJuridicalPayer: CreateJuridicalPayer, options?: RawAxiosRequestConfig): AxiosPromise<JuridicalPayer>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayerApiInterface
     */
    list(options?: RawAxiosRequestConfig): AxiosPromise<Array<JuridicalPayer>>;

}

/**
 * PayerApi - object-oriented interface
 * @export
 * @class PayerApi
 * @extends {BaseAPI}
 */
export class PayerApi extends BaseAPI implements PayerApiInterface {
    /**
     * 
     * @param {CreateJuridicalPayer} createJuridicalPayer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayerApi
     */
    public createJuridical(createJuridicalPayer: CreateJuridicalPayer, options?: RawAxiosRequestConfig) {
        return PayerApiFp(this.configuration).createJuridical(createJuridicalPayer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayerApi
     */
    public list(options?: RawAxiosRequestConfig) {
        return PayerApiFp(this.configuration).list(options).then((request) => request(this.axios, this.basePath));
    }
}

